import { gql } from "@apollo/client";

export const ADD_CLIENT_EMAIL_CONNECTION = gql`
  mutation addClientEmailConnection($input: AddClientEmailConnectionInput!) {
    client {
      addClientEmailConnection(input: $input) {
        id
        success
      }
    }
  }
`;
